import React from "react";

const Base = ({ title = "", description = "", className = "", children }) => {
  return (
    <div>
      <header className="header mt-auto py-3" style={{ fontFamily: "Georgia" }}>
        <div className="container text-center">
          <br />
          <br />
          <h1
            style={{ fontSize: "13vmin", marginTop: "8vmin" }}
            className=" text-white"
          >
            {title}
          </h1>
          <p className="lead">{description}</p>
          <br />
        </div>
      </header>
      <div className={className} style={{ marginBottom: "3rem" }}>
        {children}
      </div>
    </div>
  );
};

export default Base;
